import { accountPreferenceAction } from "app/store/accountPreference/actions/accountPreferenceAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showList: false,
  account: {},
  selectedAccount: "",
  editPreference: false,
  toggleAccount: false,
};

const accountPreferenceSlice = createSlice({
  name: "accountPreference",
  initialState: initialState,
  reducers: accountPreferenceAction,
});

export const { showPreferenceList, toggleEditPreference, toggleAccountFilter } =
  accountPreferenceSlice.actions;

export default accountPreferenceSlice.reducer;
